/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useUser } from '../context/user'
import { getMyPrivateNotes } from '../server/server'
import { format_day, datesAreOnSameDay } from '../utils/util'
import Note from './Note'
import MuchWorse from '../svg/MuchWorse'
import Same from '../svg/Same'
import MuchBetter from '../svg/MuchBetter'
import Spyhole from '../svg/Spyhole'
import '../styles/PrivateNotes.css'
import { decrypt } from '../utils/crypto'
import { FaAngleLeft } from 'react-icons/fa'
import SecretKeyModal from './Modal/SecretKeyModa'
import { useTranslation } from 'react-i18next'
import i18n from '../i18n'

const mood = {
    Worse: <MuchWorse />,
    'Much worse': <MuchWorse />,
    Same: <Same />,
    Better: <MuchBetter />,
    'Much better': <MuchBetter />,
}

export default function PrivateNotes(props) {
    const secretKey = localStorage.getItem('secret_key')
    const { user } = useUser()
    const { t } = useTranslation()
    const [notes, setNotes] = useState([])
    const [secretKeyModalIsOpen, setSecretKeyModalOpen] = useState(!secretKey)
    const [selectedNote, setSelectedNote] = useState()
    const closeModal = () => setSecretKeyModalOpen(false)
    const loadNotes = async () => {
        const resp = await getMyPrivateNotes()
        if (resp.status === 200) {
            const results = resp.data
            setNotes(results.data)
        }
    }

    useEffect(() => {
        loadNotes()
    }, [])

    const NotePreview = ({ note }) => {
        const yesterdayEmotion = note.last_daily_feedback?.emotion
        const todayEmotion = note.today_daily_feedback?.emotion

        return (
            <div className="private-note-preview" onClick={() => setSelectedNote(note)}>
                <div className="note-details">
                    <div className="note-name">{decrypt(note.name, secretKey) || t('dayReview')}</div>
                    <div className="note-mood">{note.compare && mood[note.compare]}</div>
                </div>
                <div className="note-details">
                    <div>
                        {note.type === 'daily_feedback' && (
                            <div className="note-type row-direction">
                                <div className={`${yesterdayEmotion}-emotion margin-left`}>{yesterdayEmotion && t(yesterdayEmotion.toLowerCase())}</div>
                                <div className={`${todayEmotion}-emotion margin-left`}>{todayEmotion && t(todayEmotion.toLowerCase())}</div>
                            </div>
                        )}
                        {note.type === 'day_reflection' && <span className="note-type note-daily-reflection">{t('dailyReflection')}</span>}
                    </div>
                    <div className="note-type note-daily-reflection" style={{ direction: 'ltr' }}>
                        {format_day(note.created_date)}
                    </div>
                </div>
            </div>
        )
    }

    const renderNotes = () => {
        return notes.map((note, index) => {
            const previousNote = index > 0 && notes[index - 1]
            const previousNoteDay = previousNote?.created_date
            const sameDay = !!previousNoteDay && datesAreOnSameDay(new Date(note.created_date), new Date(previousNoteDay))

            return (
                <div key={index}>
                    {!sameDay && (
                        <div className="note-time" style={{ direction: 'ltr' }}>
                            {format_day(note.created_date)}
                        </div>
                    )}
                    <NotePreview note={note} />
                </div>
            )
        })
    }

    const NotesList = () => {
        return (
            <div className="single-notes-block">
                <div className="private-notes-list-block">
                    <div className="private-notes-info">
                        <Spyhole />
                        <span>{t('thisIsYourSafePlaceAndNothingWillBeShared')}</span>
                    </div>

                    <div className="notes-list">{renderNotes()}</div>
                </div>
            </div>
        )
    }

    const NotesListWithNoteOpened = () => {
        return (
            <div className="note-section">
                <Note note={selectedNote} />
            </div>
        )
    }

    return (
        <div className="private-notes-container">
            {!!selectedNote && (
                <button
                    className={`back-personal-note ${i18n.language === 'ar' ? 'change-button-position' : ''}`}
                    onClick={() => {
                        setSelectedNote(null)
                    }}
                    style={{ transform: i18n.language === 'ar' ? 'scaleX(-1)' : 'none' }}
                >
                    <FaAngleLeft />
                </button>
            )}
            <div className="notes-title">{t('yourPrivateNotes')}</div>

            {selectedNote ? <NotesListWithNoteOpened /> : <NotesList />}
            <SecretKeyModal isOpen={secretKeyModalIsOpen} onRequestClose={closeModal} />
        </div>
    )
}
